const PLACE = {
  คลังรูปพรรณเก่า: {
    status_code: 'OLD',
    description: 'คลังรูปพรรณเก่า',
  },
  คลังรูปพรรณใหม่: {
    status_code: 'NEW',
    description: 'คลังรูปพรรณใหม่',
  },
  // คลังอื่นๆ: {
  //   status_code: 'OTHER',
  //   description: 'คลังอื่นๆ',
  // },
};

export default PLACE;
